import {
  PayeeRequirement,
  RequirementStatus,
  SharedFileRequest,
  SharedFileRequestStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export const selectorIsRequirementReadyToUploadFile = (
  requirement: PayeeRequirement,
  sharedFile?: SharedFileRequest
): boolean => {
  return (
    !!sharedFile &&
    (selectorIsSharedFileNotNoneContext(sharedFile?.contextType)
      ? sharedFile.status === SharedFileRequestStatus.PENDING_UPLOAD
      : requirement.dataSourceStatus !== RequirementStatus.COMPLETED)
  );
};
